import { render, staticRenderFns } from "./ProfitRateModal.vue?vue&type=template&id=12fc45ae&"
import script from "./ProfitRateModal.vue?vue&type=script&lang=ts&"
export * from "./ProfitRateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports